// extracted by mini-css-extract-plugin
module.exports = {"switch":"style_switch__Kh47i","slider":"style_slider__1MeIH"};